import React from 'react';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';

import {
  validationSchema,
  initialValues,
} from '../../../../../../forms/changeRateForm';
import Modal from '../../../../../../components/Modal';

import Form from './components/Form';

export const ChangeFastCashRateModal = (props) => {
  const {
    isModalOpen,
    onModalClose,
    onSubmit,
    fastCashErrors,
    setFastCashErrors,
  } = props;

  const formik = useFormik({
    initialValues: initialValues(),
    onSubmit,
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema,
  });

  const { values, handleSubmit, setFieldValue, errors, resetForm } = formik;

  const handleCloseAndResetForm = () => {
    setFastCashErrors('');
    resetForm();
    onModalClose();
  };

  return (
    <Modal
      title="Change FastCash Rate"
      isModalOpen={isModalOpen}
      onClose={handleCloseAndResetForm}
    >
      <Form
        values={values}
        onSubmit={handleSubmit}
        setFieldValue={setFieldValue}
        onModalClose={handleCloseAndResetForm}
        errors={errors}
      />
      <p className="errors">{fastCashErrors}</p>
    </Modal>
  );
};

export default ChangeFastCashRateModal;

ChangeFastCashRateModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onModalClose: PropTypes.func.isRequired,
};
